import { Dispatch } from 'react';
import { request } from './request';
import { SessionAction } from '../interfaces/Session';

export function deleteUpload(dispatch: Dispatch<SessionAction>, id: string, rel: string, uid: string, name: string) {
  return request(dispatch, `/thicket/${id}/documents/${rel}/${uid}/${encodeURIComponent(name)}`, {
    method: 'DELETE',
  });
}